import { ReactElement } from "react";

import { FormConfig } from "@evergiving/common/dist/es2015/form";

import { LogoContainer } from "@/lib/components/LogoContainer";
import { PageContainer } from "@/lib/components/PageContainer";
import { Text } from "@/lib/components/Text";

/**
 * The link named something the form could not resolve. It says "no longer
 * valid" rather than "expired", because a truncated or tampered token is not
 * expired, and the form cannot tell the difference.
 */
export function ExpiredLinkPage({
  formConfig,
}: {
  formConfig: FormConfig;
}): ReactElement {
  return (
    <div id="container" className="expiredLink">
      <header className="small">
        <LogoContainer formConfig={formConfig} />
      </header>
      <PageContainer formConfig={formConfig}>
        <main lang={formConfig.locale}>
          {formConfig.linkNoLongerValidText ? (
            <p>
              <Text value={formConfig.linkNoLongerValidText} />
            </p>
          ) : null}
        </main>
      </PageContainer>
    </div>
  );
}
